const icon = require('vue-svgicon');
icon.register({
    'play': {
        width: 1024,
        height: 1024,
        viewBox: '0 0 1024 1024',
        data: `<path pid="0" _stroke="#000" stroke-width="18.245" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" d="M884.451 512.001L139.548 1024V0z"/>`,
    },
});
